import { EmbeddedCollection } from './EmbeddedCollection';
/**
 * Paginated Result
 */
export class Page extends EmbeddedCollection {
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvUGFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUcxRDs7R0FFRztBQUNILE1BQU0sT0FBZ0IsSUFBNEIsU0FBUSxrQkFFekQ7Q0FLQSJ9